export default "/images/87b26a1882e26cdfb7535b5a445f5fbc.avif";